import Link from "rivals/components/shared/Link";
import { setData } from "rivals/shared/utils/qa";
import styles from "./RankCell.module.scss";
import type { Props } from "./types";

const DATA_PHILTER = "rank-cell";

export default function RankCell({ href, rank }: Props): React.JSX.Element {
  const contents = (
    <div className={styles.container} {...setData(DATA_PHILTER)}>
      {rank}
    </div>
  );

  if (href) {
    return <Link href={href}>{contents}</Link>;
  }

  return contents;
}
